import { QueryObserverResult, useQuery } from 'react-query';
import { useFetchQuery } from '../../../helpers/api';

type UseGetDownloadPerformanceReportPDFArguments = {
  caseId: string;
  actions: string;
  enabled?: boolean;
};

type UseGetDownloadPerformanceReportPDFResult = {
  url: string | undefined;
  isLoading: boolean;
  refetchReportPDF: () => Promise<
    QueryObserverResult<UseGetDownloadPerformanceReportPDFResponse>
  >;
};

type UseGetDownloadPerformanceReportPDFResponse = {
  data: string;
};

export const useGetDownloadPerformanceReportPDF = ({
  caseId,
  actions,
  enabled = false,
}: UseGetDownloadPerformanceReportPDFArguments): UseGetDownloadPerformanceReportPDFResult => {
  const { fetchQuery } = useFetchQuery();

  const query = useQuery<UseGetDownloadPerformanceReportPDFResponse>(
    ['cases', caseId, actions],
    fetchQuery({
      path: `/v2/cases/${caseId}/milestones/actions/${actions}/download`,
    }),
    {
      cacheTime: 0,
      enabled: !!caseId && !!actions && enabled,
      retry: false,
    },
  );

  return {
    url: query.data?.data || '',
    isLoading: query.isLoading,
    refetchReportPDF: query.refetch,
  };
};
